// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/scss/home.scss
// module id = 389
// module chunks = 2